import { Modal } from "antd";
import Button from "../Button";
import React from "react";
import { useTranslation } from "react-i18next";
interface FullScreenModalProps {
  openModal: boolean;
  setOpenModal: (open: boolean) => void;
  title: string;
  bodyContent: JSX.Element;
  onConfirm: Function;
  needBasicFooter?: boolean;
  needCustomFooter?: Function;
}

const FullScreenModal = ({
  openModal,
  setOpenModal,
  title,
  bodyContent,
  onConfirm,
  needBasicFooter = true,
  needCustomFooter,
}: FullScreenModalProps) => {
  const { t } = useTranslation();
  const renderFooterButton = () => {
    return (
      <>
        <Button
          className="close-button"
          text={t("APP.FULLSCREENMODAL.CLOSE", { defaultValue: "Fermer" })}
          onClick={() => setOpenModal(false)}
          style={{ marginRight: "10px" }}
        />
        <Button
          className="purple-button"
          text={t("APP.FULLSCREENMODAL.CONFIRM", { defaultValue: "Confirmer" })}
          onClick={() => {
            onConfirm();
            setOpenModal(false);
          }}
        />
      </>
    );
  };

  return (
    <>
      <Modal
        title={title}
        centered
        open={openModal}
        onOk={() => {
          onConfirm();
          setOpenModal(false);
        }}
        onCancel={() => setOpenModal(false)}
        width={4000}
        footer={() =>
          needCustomFooter ? (
            needCustomFooter()
          ) : needBasicFooter ? (
            renderFooterButton()
          ) : (
            <></>
          )
        }
      >
        <div style={{ height: "75vh" }}>{bodyContent}</div>
      </Modal>
    </>
  );
};

export default FullScreenModal;
